<template>
<div class="chapter">
<div class="inner_page">
<h1>Table of Contents</h1>
<p><span href="#/c001" title="Link target outside of Sample">Title Page</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Page</span></p>
<p><a href="#/c003">DEDICATION</a></p>
<p><span href="#/c004" title="Link target outside of Sample">MOTHER’S DAY SALE THIS WEEK ON ALL THESE BOOKS! | The Master Chefs Series and World</span></p>
<p><span href="#/c005" title="Link target outside of Sample">More Romances from Kailin Gow | THE LOVING SUMMER SERIES</span></p>
<p><span href="#/c006" title="Link target outside of Sample">THE NEVER KNIGHTS SERIES</span></p>
<p><span href="#/c007" title="Link target outside of Sample">SESSIONS: SEX SHRINK OF SEATTLE SERIAL</span></p>
<p><span href="#/c008" title="Link target outside of Sample">FILTHY DIRTY LAUNDRY SERIAL</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Short, Sassy, and Sexy Romantic Comedy Reads from Kailin Gow’s Pen Names</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Fantasy Romance Books from Kailin Gow</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Cookbooks, Lifestyle and Self-Help Books from Kailin Gow | The Perfect Cup:  Tea | Kailin Gow's Go Girl Guide to SUPERFOODS (Kailin Gow's Go Girl Guides Book 1) | Kailin Gow’s Go Girl Guide to Going for It (Kailin Gow’s Go Girl Guides)</span></p>
<p><span href="#/c012" title="Link target outside of Sample">Raising A Strong Daughter: What Fathers Should Know</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Get a FREE AUDIOBOOK Copy of Kailin Gow’s Go Girl Guide to Superfoods Audiobook when it Releases in May 2018 and get notified of Kailin’s New Releases, Contests, Promos, and More! | https://www.subscribepage.com/g9r7j6</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?a25c5f44